module.exports = __webpack_public_path__ + "static/media/instagramOrange.ff0e20de.png";